import React, { ReactNode } from "react";
import { useFormHandlerContext } from "../../../controllers/formController";
import { Collapse, Tabs, Tab, Box } from "@mui/material";
import UserAttributeMetadataContent from "./UserAttributeMetadataContent";
import { useInputFullName } from "../fields/subForms/NamePrefixContext";

interface UserAttributeMetadataTabsProps {
  children: ReactNode;
  name?: string;
  state: "data" | "metadata";
  onTabChange: (state: "data" | "metadata") => void;
}

const UserAttributeMetadataTabs: React.FC<UserAttributeMetadataTabsProps> = ({
  children,
  name,
  state,
  onTabChange,
}) => {
  const { hasMetadataField } = useFormHandlerContext();

  const fullName = useInputFullName(name);

  return hasMetadataField(fullName) ? (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={state}
        onChange={(_event, newValue) =>
          onTabChange(newValue as "data" | "metadata")
        }
      >
        <Tab label="Data" value="data" />
        <Tab label="Metadata" value="metadata" />
      </Tabs>
      <Box mt={2}>
        <Collapse in={state === "data"}>{children}</Collapse>
        <Collapse in={state === "metadata"}>
          <UserAttributeMetadataContent name={fullName} />
        </Collapse>
      </Box>
    </Box>
  ) : (
    <>{children}</>
  );
};

export default UserAttributeMetadataTabs;
